import api from './api';

export const getsCajaChica = async (params = {}) => {
    const res = await api.get('/CajaChica/GetsCajaChica', { params });
    return res.data;
};

export const getCajaChicaById = async (id) => {
    const res = await api.get('/CajaChica/GetCajaChicaById', { params: { id } });
    return res.data;
};

export const postAperturaCajaChica = async (model) => {
    const res = await api.post('/CajaChica/PostAperturaCajaChica', model);
    return res.data?.data;
};

export const postCierreCajaChica = async (idCajaChica, observaciones = '') => {
    const res = await api.post(`/CajaChica/PostCierreCajaChica?idCajaChica=${idCajaChica}&observaciones=${encodeURIComponent(observaciones)}`);
    return res.data?.data;
};

export const getsMovimientos = async (params = {}) => {
    const res = await api.get('/CajaChica/GetsMovimientos', { params });
    return res.data;
};

export const postMovimiento = async (model) => {
    const res = await api.post('/CajaChica/PostMovimiento', model);
    return res.data?.data;
};

export const anularMovimiento = async (idMovimiento, motivo = '') => {
    const res = await api.post(`/CajaChica/AnularMovimiento?idMovimiento=${idMovimiento}&motivo=${encodeURIComponent(motivo)}`);
    return res.data?.data;
};

export const getsConceptosGasto = async () => {
    const res = await api.get('/CajaChica/GetsConceptosGasto');
    return res.data;
};

export const postConceptoGasto = async (descripcion, abreviado = '') => {
    const res = await api.post(`/CajaChica/PostConceptoGasto?descripcion=${encodeURIComponent(descripcion)}&abreviado=${encodeURIComponent(abreviado)}`);
    return res.data?.data;
};

const cajaChicaService = {
    getsCajaChica,
    getCajaChicaById,
    postAperturaCajaChica,
    postCierreCajaChica,
    getsMovimientos,
    postMovimiento,
    anularMovimiento,
    getsConceptosGasto,
    postConceptoGasto
};

export default cajaChicaService;
